import { useQuery } from 'react-query';
import axios from '../utils/axios-util';

const fetchConfigRegions = () => {
  return axios({
    url: '/config/regions',
    method: 'get'
  });
};

const useGetConfigRegions = () => {
  return useQuery(['admin', 'regions'], fetchConfigRegions);
};

export default useGetConfigRegions;
